// ============================================================================
// API — Métodos de pago (panel-cliente)
//
// La pantalla de pagos lee los métodos de pago ACTIVOS desde `metodos_pago`
// (configuración administrada por el Super Admin) y la configuración global
// de pagos (`configuracion_pagos`). No hay datos bancarios hardcodeados.
// ============================================================================

import { supabaseClient } from '@plataforma/supabase-client';

/**
 * Lista los métodos de pago ACTIVOS ordenados para la pantalla de pagos.
 * La RLS solo expone a usuarios normales los métodos activos.
 */
export async function listarMetodosPagoActivos() {
  const { data, error } = await supabaseClient()
    .from('metodos_pago')
    .select(
      'id, nombre, slug, tipo, numero, cci, qr_url, instrucciones, orden, titular_personalizado',
    )
    .eq('activo', true)
    .order('orden', { ascending: true });

  return { data, error };
}

/**
 * Obtiene la configuración global de pagos (titular general).
 */
export async function obtenerConfigPagos() {
  const { data, error } = await supabaseClient()
    .from('configuracion_pagos')
    .select('titular_general')
    .eq('id', 1)
    .maybeSingle();

  return { data: data ?? null, error };
}
